export default class SupportSettings {
  static SERVICE_NAME = 'supportSettings';

  constructor({ app }) {
    this.axios = {
      withToken() {
        return app.$axios.create({
          baseURL : process.env.INTEGRATE_MODULE_API,
          headers : {
            Accept            : 'application/json',
            'Content-Type'    : 'application/json',
            'x-api-key'       : process.env.INTEGRATE_MODULE_API_KEY,
            'Accept-Language' : app.i18n.locale,
            Authorization     : app.$token.get()
          }
        });
      }
    };
  }

  getAllSupportSettings(params) {
    return this.axios.withToken().get(`/support-settings`, { params });
  }
}
